// extracted by mini-css-extract-plugin
export default {"PACreateFormContainer":"TJcKCTlC","PACreateHeaderPanel":"KCsmNeJ3"};